import { CSS } from '@grupoboticario/flora-react'

export const modalWrapperCss: CSS = {
  width: '100%'
}

export const bodyTextCss: CSS = {
  lineHeight: '24px'
}
